@import "../../../styles/mixins/svs-design-system";
@import "../../../styles/variables";

.product-catalog-selector {
  box-sizing: border-box;
  background-color: white;
  text-decoration: none;
  padding-left: 19px;
  padding-bottom: 20px;
  padding-top: 20px;
  padding-right: 20px;
  border: 2px solid white;
}

.product-catalog-selector-link {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin-right: var(--margin-right-product-catalog-banner, 20);
  -webkit-box-shadow: 0px 2px 10px 0px rgba(51, 51, 51, 0.12);
  box-shadow: 0px 2px 10px 0px rgba(51, 51, 51, 0.12);
  background-color: var(--se-alternative);
  border: var(--se-divider);
  border-radius: 0px;
  border-width: 0px;
  border-top-width: 3px;
  border-top-color: transparent;
  border-style: solid;
  position: relative;
}

.product-selector-link:focus {
  .cta-product-selector {
    border: 2px solid black;
  }
}

.product-selector-header {
  display: flex;
  margin-right: 10px;
}

.support-icon {
  margin-left: -8px;
  color: var(--qds-theme-signature-color-default, #008a16);
}
.subtitle1 {
  font-size: 18px;
  font-weight: bold;
  margin-top: 20px;
  color: #333333;
  margin-bottom: 0;
}

.subtitle2 {
  font-size: 14px;
  margin-top: 15px;
  margin-bottom: 0px;
  color: #333333;
}

.support-link {
  text-decoration: none;
  font-size: 16px;
  margin: 25px 0px 0px 0px;
  color: #1a0dab;
}

.link {
  text-decoration: none;
}

.widget-container {
  box-sizing: border-box;
  background-color: #e6e6e6;
  margin-bottom: 20px;
  cursor: pointer;
  overflow: hidden;
  text-decoration: none;
  @include shadow-small;

  .header {
    text-decoration: none;
    color: #333333;
    display: block;
    height: 96px;
    &:focus-visible {
      overflow: hidden;
    }
  }

  &:hover {
    @include shadow-medium;
  }

  @media (min-width: $uiaas-tablet) {
    margin: 0px 20px 20px 0;
  }

  .content {
    display: flex;
    flex-direction: column;
    @media (min-width: $uiaas-tablet) {
      flex-direction: row;
    }
  }

  .result-card__title {
    text-decoration: none;
  }
}

.widget-title {
  overflow: hidden;
  color: var(--srp-greyscale-anthracite-grey-333333, #333);
  text-overflow: ellipsis;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px;
}

.widget-details {
  overflow: hidden;
  color: var(--srp-greyscale-anthracite-grey-333333, #333);
  text-overflow: ellipsis;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
}

.widget-content {
  padding: 20px 20px 20px 12px;
}

.widget-global-icon {
  padding: 20px 0px 20px 20px;
  display: flex;
}

.widget-icon {
  padding: 20px;
  margin-top: 14.5px;
  margin-left: auto;
  display: flex;
}
